import { Typography } from "antd"

const { Text } = Typography

// A table's number cell renderer: a zero reads muted (DAA-4-06), and so does a share that rounds to
// nothing, such as "0.0%".
export const numberCell = (format) => (value) => {
  const text = format(value)

  return text === format(0) ? <Text type="secondary">{text}</Text> : text
}
